<template lang="pug">
  .popup-dispatcher
    component(v-if="popup && popup.component" :is="popup.component" ref="popup")
</template>

<script>
import model from '@/model/popup';

export default {
  name: 'PopupDispatcher',
  computed: {
    popup() { return this.$store.state.popup.items[0] ?? null; },
  },
  watch: {
    popup(val) {
      if (!val) return;

      this.$nextTick(() => {
        this.$refs.popup.open(...(val.args ?? [])).then(r => { model.resolve(this.popup, r); });
      });
    },
  },
  methods: {},
};
</script>

<style scoped>

</style>
